export default __webpack_public_path__ + "static/media/exp_E.aaad238e.png";